import { MoreHorizontal } from 'lucide-react';
import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar.tsx';
import { Button } from '../ui/button.tsx';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../ui/dropdown.tsx';
import { TableCell, TableRow } from '../ui/table.tsx';
import { Textarea } from '../ui/textarea.tsx';
import { useMemo, useState } from 'react';
import {
  useGetRecordByEnrollmentID,
  useUpsertRecord,
} from '../../api/record/recordQueries.js';

// marksObtained, grade, recordTypeId, childId, subjectId, enrollmentId, comment
const StudentRecordRowData = ({ enrollment, recordTypeId }) => {
  const [record, setRecord] = useState({
    marksObtained: 0,
    grade: '',
    recordTypeId: recordTypeId,
    childId: enrollment.child.childId,
    subjectId: enrollment.subject.id,
    enrollmentId: enrollment.enrollmentId,
    comment: '',
  });

  const { mutate: upsert } = useUpsertRecord();
  const {
    data: RecordData,
    isLoading: isRecordLoading,
    isError: isRecordError,
  } = useGetRecordByEnrollmentID(enrollment.enrollmentId, recordTypeId);

  // Get record data
  useMemo(() => {
    if (isRecordLoading || isRecordError || !RecordData) {
      setRecord({
        marksObtained: 0,
        grade: '',
        recordTypeId,
        childId: enrollment.child.childId,
        subjectId: enrollment.subject.id,
        enrollmentId: enrollment.enrollmentId,
        comment: '',
      });
      return;
    }
    setRecord({
      marksObtained: RecordData.marksObtained,
      grade: RecordData.grade,
      recordTypeId,
      childId: enrollment.child.childId,
      subjectId: enrollment.subject.id,
      enrollmentId: enrollment.enrollmentId,
      comment: RecordData.comment,
    });
    return;
  }, [isRecordLoading, isRecordError, RecordData, enrollment, recordTypeId]);

  const handleSave = () => {
    upsert({
      ...record,
    });
  };

  // Use date to fetch the record as well
  return (
    <TableRow
      key={enrollment.id}
      className="hover:bg-gray-50 divide-x divide-gray-200"
    >
      <TableCell>
        <div className="flex items-center">
          <Avatar className="mr-2">
            <AvatarImage
              src={enrollment.child.photoUrl || '/placeholder.svg'}
              alt={`${enrollment.child.firstName} ${enrollment.child.lastName}`}
            />
            <AvatarFallback>
              {/* {student.name.substring(0, 2)} */}
              PD
            </AvatarFallback>
          </Avatar>
          {/* <span>{student.name}</span> */}
          <span>
            {enrollment.child.firstName} {enrollment.child.lastName}
          </span>
        </div>
      </TableCell>
      <TableCell>
        <div className="flex items-center">
          <input
            type="number"
            min="0"
            max="100"
            value={record.marksObtained}
            onChange={(e) =>
              setRecord({ ...record, marksObtained: Number(e.target.value) })
            }
            className="w-16 text-center border border-gray-300 rounded-md"
          />
          <span className="ml-2">%</span>
        </div>
      </TableCell>
      <TableCell>
        <div className="flex items-center">
          <input
            type="text"
            placeholder="e.g. A+, B"
            value={record.grade}
            onChange={(e) => setRecord({ ...record, grade: e.target.value })}
            className="w-16 text-center border border-gray-300 rounded-md"
          />
        </div>
      </TableCell>
      <TableCell className="w-1/2">
        <Textarea
          placeholder="Enter a Comment..."
          className="min-h-[80px] resize-none"
          value={record.comment}
          onChange={(e) => setRecord({ ...record, comment: e.target.value })}
        />
      </TableCell>
      <TableCell>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size="icon" className="h-8 w-8">
              <MoreHorizontal className="h-4 w-4" />
              <span className="sr-only">Open menu</span>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem className="cursor-pointer" onClick={handleSave}>
              Save
            </DropdownMenuItem>
            <DropdownMenuItem className="cursor-pointer">
              View Profile
            </DropdownMenuItem>
            <DropdownMenuItem className="cursor-pointer">
              View Submission
            </DropdownMenuItem>
            <DropdownMenuItem className="cursor-pointer">
              Send Feedback
            </DropdownMenuItem>
            <DropdownMenuItem className="cursor-pointer">
              Grant Extension
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </TableCell>
    </TableRow>
  );
};

export default StudentRecordRowData;
